module.exports = __webpack_public_path__ + "static/media/2 Minutes of Directors Meeting held on 27th August 2021.aded27d8.pdf";